<template>
  <el-dialog
    :title="this.id ? '修改设备类型' : '新增设备类型'"
    @close="handleCancle"
    @closed="reset"
    :visible="visible"
    :close-on-click-modal="false"
    width="500px"
  >
    <el-form ref="typeForm" :model="typeForm" :rules="typeFormRules" label-width="110px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="设备类型名称" prop="categoryName">
            <!-- <el-input
              v-if="!isDetail"
              v-model="typeForm.categoryName"
              :maxlength="50"
              placeholder="请输入"
            ></el-input>
            <span v-else>{{ typeForm.categoryName }}</span> -->
            <el-input
              v-model="typeForm.categoryName"
              :maxlength="50"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="设备类型编码" prop="categoryNo">
            <!-- <el-input
              v-if="!isDetail"
              :maxlength="50"
              v-model="typeForm.categoryNo"
              placeholder="请输入"
            ></el-input>
            <span v-else>{{ typeForm.categoryNo }}</span> -->
            <el-input :maxlength="50" v-model="typeForm.categoryNo" placeholder="请输入"></el-input>
            <NoTips />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="状态" prop="status">
            <!-- <el-radio-group v-if="!isDetail" v-model="typeForm.status">
              <el-radio :label="0">启用</el-radio>
              <el-radio :label="1">停用</el-radio>
            </el-radio-group>
            <span v-else>{{ typeForm.status }}</span> -->
            <el-radio-group v-model="typeForm.status">
              <el-radio v-for="(item, index) in statusType" :key="index" :label="item.typeNum">{{
                item.typeName
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancle">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="handleSubmit">确定</el-button>
    </span>
    <el-dialog append-to-body width="400px" title="提示" :visible="pushVisible">
      <el-row>
        <span>新增设备类型成功，确认是否跳转功能参数。</span>
      </el-row>
      <el-row slot="footer" class="dialog-footer" @close="handleNoPush">
        <el-button @click="handleNoPush">取消</el-button>
        <el-button type="primary" @click="handlePush">确定</el-button>
      </el-row>
    </el-dialog>
    <ValidatPass ref="validatPass" @back="validateBack" />
  </el-dialog>
</template>
<script>
import { isEmpty } from 'lodash';
import deviceTypeApi from 'api/home/device-mangement/device-type';
import validatePassApi from 'api/home/validatePass';
import ValidatPass from '@/components/PermissionPassword/ValidatPass';
import statusType from '@/config/status';
import regex from '@/config/regex';
import NoTips from '../device-components/NoTips';
export default {
  components: {
    ValidatPass,
    NoTips
  },
  data() {
    const validateNo = (rule, value, callback) => {
      const { noReg } = regex;
      if (!value) {
        callback(new Error('请输入设备类型编码'));
        return;
      }
      if (!noReg.test(value)) {
        callback(new Error('请用拼音或相应英文设置编码，以"_"或"-"进行连接'));
      } else {
        callback();
      }
    };
    return {
      //匹配多个_
      // regex: /^[a-zA-Z]+(_[a-zA-Z]+)*$/,
      //匹配单个_或无_
      regex: /^[a-zA-Z]+((_|-)[a-zA-Z]+)?$/,
      statusType,
      id: '',
      isDetail: false,
      visible: false,
      btnLoading: false,
      typeForm: {
        categoryName: '',
        categoryNo: '',
        status: 0
      },
      typeFormRules: {
        categoryName: [{ required: true, message: '请输入设备类型名称', trigger: 'blur' }],
        categoryNo: [{ required: true, validator: validateNo, trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      pushVisible: false
    };
  },
  methods: {
    init(data) {
      this.visible = true;
      if (!isEmpty(data)) {
        this.$nextTick(() => {
          this.typeForm.categoryName = data.categoryName;
          this.typeForm.categoryNo = data.categoryNo;
          this.typeForm.status = data.status;
          this.id = data.id;
        });
      }
    },
    handleCancle() {
      !this.btnLoading && (this.visible = false);
    },
    handleSubmit() {
      this.$refs.typeForm.validate(validated => {
        if (!validated) {
          return;
        }
        if (this.id) {
          this.editType();
        } else {
          this.addType();
        }
      });
    },
    addType() {
      this.btnLoading = true;
      deviceTypeApi
        .addDeviceType(this.typeForm)
        .then(res => {
          if (res.data.code !== 200) {
            return;
          }
          this.$message.success('新增设备类型成功');
          this.$emit('back', 0);
          this.pushVisible = true;
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    editType() {
      const data = {
        id: this.id,
        ...this.typeForm
      };
      this.$refs.validatPass.init(data, 7, true);
    },
    validateBack() {
      this.$message.success('设备类型修改成功');
      this.$emit('back', 1);
      this.visible = false;
    },
    handleNoPush() {
      this.pushVisible = false;
      this.visible = false;
    },
    handlePush() {
      this.$router.push({ path: '/home/deviceparameter' });
    },
    reset() {
      this.$refs.typeForm.resetFields();
      this.btnLoading = false;
      this.id = '';
      this.isDetail = false;
      this.pushVisible = false;
    }
  }
};
</script>